import React from 'react';

import useFocusTrap from 'hooks/useFocusTrap';

const FocusTrap = ({ children, shouldFocusFirstElement, active }) => {
  const ref = useFocusTrap({ shouldFocusFirstElement, active });
  return (
    <>
      {children(ref)}
    </>
  );
};

export default FocusTrap;
